export default "__VITE_ASSET__CpmxrqV$__"